<template>
  <v-layout row>
    <v-dialog v-model="dialog" persistent @input="onDialogOpened" content-class="dialog-custom">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">
          <v-icon class="mr-2">add_circle</v-icon>
          ADICIONAR CONTRATAÇÃO
        </v-btn>
      </template>
      <v-card>
        <v-card-text class="primary modal-title" style="flex-shrink: 0;">
          <span>Adicionar Contratação</span>
        </v-card-text>
        <div class="scrollable-body">
        <v-container class="pa-3 white mt-3" style="">
          <v-layout wrap>
              <v-flex xs12 sm6 pb-0>
              <v-select
                  :items="unidadesOrganizacionais.itens"
                  item-text="sigla"
                  item-value="id"
                  v-model="selectedOrgaoId"
                  required
                  placeholder="Selecione"
              >
                <template v-slot:label>
                  Órgão <span class="red--text">*</span>
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 sm6 pb-0>
              <v-select
                  :items="credenciados"
                  v-model="selectedCredenciado"
                  required
                  placeholder="Selecione"
                  :disabled="credenciados.length === 0"
              >
                <template v-slot:item="{ item }">
                  {{ item.classificacao }}º Lugar - {{ item.nomeRazaoSocial }}
                </template>

                <template v-slot:selection="{ item }">
                  {{ item.classificacao }}º Lugar - {{ item.nomeRazaoSocial }}
                </template>

                <template v-slot:label>
                  Credenciado <span class="red--text">*</span>
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12>
              <div v-if="credenciados.length === 0" class="red--text text-caption mt-1">
                Não há fornecedores classificados em definitivo para este credenciamento.
              </div>
            </v-flex>

            <v-flex xs12>
              <v-textarea
                  v-show="!this.deveJustificarEscolha"
                  placeholder="Informe o motivo"
                  v-model="motivo"
                  :rules="motivoRules"
                  rows="2"
                  auto-grow
                  counter="300"
                  maxlength="300"
              >
                <template v-slot:label>
                  Motivo Escolha <span class="red--text">*</span>
                </template>
              </v-textarea>
            </v-flex>
            <div style="max-height: 58vh; height: 580px; overflow-y: auto; width: 100%;">
              <v-data-table
                  v-if="selectedCredenciado && selectedOrgaoId && itens.length > 0"
                  :headers="headers"
                  :items="itens"
                  class="custom-header"
                  :rows-per-page-items="[totalItens]"
                  :options="paginacaoInterna"
                  hide-actions
                  style="width: 100%">
                <template v-slot:items="props">
                  <td>{{ props.item.tipoItem }}</td>
                  <td>{{ props.item.sequencia }}</td>
                  <td>
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <v-tooltip top class="tooltip-arredondado">
                        <template #activator="{ on, attrs }">
                          <chip-round
                            v-bind="attrs"
                            v-on="on"
                            :label="getTipoMaterialServico(props.item.tipo, 'sigla')"
                            :tamanho-fonte="'11px'"
                          />
                        </template>
                        <span style="white-space: nowrap;">
                          {{ getTipoMaterialServico(props.item.tipo, 'text') }}
                        </span>
                      </v-tooltip>
                      <div>
                        <span v-if="!props.item.verDescricaoCompleta">
                          {{
                            props.item.descricao.length > 250 ? props.item.descricao.slice(0, 250) + '...' : props.item.descricao
                          }}
                          <v-btn
                              v-if="props.item.descricao.length > 250"
                              text
                              small
                              @click="props.item.verDescricaoCompleta = true"
                          >
                            Ver mais
                          </v-btn>
                        </span>
                        <span v-else>
                          {{ props.item.descricao }}
                          <v-btn
                              text
                              small
                              @click="props.item.verDescricaoCompleta = false"
                          >
                            Ver menos
                          </v-btn>
                        </span>
                      </div>
                    </div>
                  </td>
                  <td>{{ props.item.unidadeAquisicao }}</td>
                  <td class="text-xs-center">{{ props.item.quantidadeDisponivel }}</td>
                  <td style="vertical-align: middle;">
                    <div class="d-flex align-center justify-end">
                      <v-text-field
                          placeholder=""
                          single-line
                          style="width: 30px; text-align: center"
                          min="0"
                          :max="props.item.quantidadeDisponivel"
                          v-model="props.item.quantidade"
                      />
                    </div>
                  </td>
                </template>
              </v-data-table>
            </div>
          </v-layout>
          <v-snackbar
              :value="snackbar.visible" :timeout="snackbar.timeout"
              :color="snackbar.color"
              :top="snackbar.top"
              :right="snackbar.right"
              :multi-line="snackbar.multiLine"
          >
            {{ snackbar.message }}
            <v-btn flat dark @click="snackbar.visible = false">
              <v-icon small>close</v-icon>
            </v-btn>
          </v-snackbar>
        </v-container>
        </div>
        <v-card-actions class="pa-3" style="flex-shrink: 0; flex-direction: column; gap: 1rem;">
          <div style="width: 100%;">
            <paginacao-tabela
                v-if="selectedCredenciado && selectedOrgaoId && itens.length > 0"
                show-items-per-page
                :page="paginacaoInterna.page"
                :itemsPerPage="paginacaoInterna.rowsPerPage"
                :totalPaginas="totalPaginas"
                :totalItens="totalItens"
                @update-page="tratarEventoAtualizarPagina"
                @update-items-per-page="tratarEventoAtualizarItensPorPagina"
            >
              <template #pagination-actions>
                <slot name="pagination-actions"></slot>
              </template>
            </paginacao-tabela>
          </div>

          <div style="width: 100%; display: flex; justify-content: space-between;">
            <v-btn color="blue darken-1" outline style="border-radius: 3px" flat @click="dialog = false">
              Voltar
            </v-btn>
            <v-btn
                v-show="selectedOrgaoId && selectedCredenciado"
                class="primary white--text"
                style="border-radius: 3px"
                flat
                @click="adicionarDemanda"
            >
              Adicionar
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import actionTypes from "@/commons/constants/action-types";
import PaginacaoTabela from "@/commons/components/PaginacaoTabela.vue";
import ChipRound from "@/views/credenciamento/detalhe-credenciamento/commons/ChipRound.vue";

export default {
  name: 'CredenciamentoModalNovaDemanda',
  components: {PaginacaoTabela, ChipRound},
  data () {
    return {
      dialog: false,
      licitacaoId: null,
      orgaoId: null,
      selectedOrgaoId: null,
      selectedCredenciado: null,
      deveJustificarEscolha: false,
      motivo: null,
      motivoRules: [
        v => (v && v.trim().length > 0) || 'O motivo é obrigatório',
        v => (v && v.trim().length >= 5) || 'O motivo deve ter no mínimo 5 caracteres',
        v => (v && v.trim().length <= 300) || 'O motivo deve ter no máximo 300 caracteres',
      ],
      unidadesOrganizacionais: [],
      credenciados: [],
      itens: [],
      headers: [
        { text: 'Tipo', value: 'tipoItem', sortable: false, width: '100px'},
        { text: 'Seq.', value: 'sequencia', sortable: false, width: '80px'},
        { text: 'Código/Descrição', value: 'descricao', sortable: false },
        { text: 'Un. Aquisição', value: 'unidadeAquisicao', sortable: false },
        { text: 'Disponível', value: 'quantidadeDisponivel', sortable: false },
        { text: 'Quantidade', value: 'quantidade', sortable: false }
      ],
      snackbar: {
        visible: false,
        message: '',
        color: 'error',
        timeout: 4000,
        top: true,
        right: true,
        multiLine: false
      },
      totalItens: 0,
      totalPaginas: 0,
      paginacaoInterna: {
        groupBy: [],
        groupDesc: [],
        rowsPerPage: 10,
        multiSort: false,
        mustSort: false,
        page: 1,
        sortBy: 'numSequencia',
        sortByDefault: ['id'],
        descending: false,
        sortDescDefault: [true]
      },
    }
},
  watch: {
    dialog(val) {
      if (!val) {
        this.resetarCampos()
      }
    },
    selectedCredenciado: {
      immediate: true,
      async handler(novo, anterior) {
        if (novo && novo.id !== ((anterior && anterior.id) || null)) {
          this.naoDeveJustificarEscolha()
          await this.buscarItensCredenciamento()
        }
      }
    },
    selectedOrgaoId: async function (novo) {
      if (novo && this.selectedCredenciado && this.selectedCredenciado.id) {
        await this.buscarItensCredenciamento()
      }
    },
    paginacaoInterna: {
      async handler(novoValor) {
        await this.buscarItensCredenciamento(novoValor)
      },
      deep: true,
    }
  },
  methods: {
    getTipoMaterialServico(sigla, chave) {
      const mod = require('@/commons/constants/tipo-item-material-servico').default || {};
      const lista = Object.values(mod);
      const norm = v => (v || '').toString().trim().toUpperCase();
      const t = norm(sigla);
      let item = lista.find(el => norm(el.sigla) === t || norm(el.value) === t || norm(el.text) === t);
      if (!item) {
        if (t.startsWith('M')) item = lista.find(el => norm(el.value) === 'MATERIAL');
        if (!item && (t.startsWith('S') || t.startsWith('SERV'))) item = lista.find(el => norm(el.value) === 'SERVICO');
      }
      return item ? item[chave] : null;
    },
    async onDialogOpened(isOpen) {
      if (isOpen) {
        this.naoDeveJustificarEscolha()
        this.setCredenciamentoId()
        await this.buscarCredenciamento()
        await this.buscarUO()
        await this.buscarCredenciadosByCredenciamentoId()
      }
    },
    mostrarErro(mensagem) {
      this.snackbar.visible = false;
      this.$nextTick(() => {
        this.snackbar.message = mensagem;
        this.snackbar.color = 'error';
        this.snackbar.visible = true;
      });
    },
    resetarCampos() {
      this.selectedOrgaoId = null
      this.selectedCredenciado = null
      this.motivo = null
      this.itens = []
      this.deveJustificarEscolha = false
    },
    async buscarCredenciamento(){
      await this.$store.dispatch(actionTypes.BUSCAR_LICITACAO, this.licitacaoId)
      this.orgaoId = this.$store.state.licitacao.idOrgao
    },
    setCredenciamentoId(){
      this.licitacaoId = this.$route.params.id
    },
    async buscarUO(){
      const unidades = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_ORGAOS_USUARIO_POR_FUNCAO, 'Credenciamento.Editar')
      if (unidades) {
        this.unidadesOrganizacionais = unidades
        const itens = unidades.itens || [];
        if (itens.length === 1) {
          this.selectedOrgaoId = itens[0].id;
        }
      }
    },
    async buscarCredenciadosByCredenciamentoId() {
      const credenciados = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_CREDENCIADOS, this.licitacaoId)

      if (!credenciados || !credenciados.fornecedores || credenciados.fornecedores.length === 0) {
        this.credenciados = [];
        this.selectedCredenciado = null;
        return;
      }

      let listaFornecedores = credenciados.fornecedores
      const fornecedorSugerido = credenciados.fornecedorSugerido
      listaFornecedores = listaFornecedores.filter(
          f => f.id !== fornecedorSugerido.id
      )

      listaFornecedores.unshift(fornecedorSugerido)

      this.credenciados = listaFornecedores.map(fornecedor => ({
        id: fornecedor.id,
        nomeRazaoSocial: fornecedor.nomeRazaoSocial,
        classificacao: fornecedor.classificacao
      }));

      if (fornecedorSugerido) {
        this.selectedCredenciado = fornecedorSugerido;
      }
    },
    async buscarItensCredenciamento() {
      const dados = {
        credenciamentoId: this.licitacaoId,
        fornecedorId: this.selectedCredenciado.id,
        paginacao: this.paginacaoInterna,
      }

      const response = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_ITENS_CREDENCIAMENTO,
          { ...dados }
      )

      if (response) {
        this.itens = response.itens.map(item => ({
          ...item,
          quantidade: 0,
          verDescricaoCompleta: false
        }));
        this.totalItens = response.totalElements;
        this.totalPaginas = response.totalPages;
      }
    },
    atualizarPaginacaoInterna(paginacao, sortByValue, sortDescValue) {
      this.paginacaoInterna.sortBy = paginacao[sortByValue]
      this.paginacaoInterna.sortDesc = paginacao[sortDescValue]
    },
    tratarEventoAtualizarPaginacaoInterna(paginacao) {
      if (paginacao.sortBy.length === 0) {
        return this.atualizarPaginacaoInterna(paginacao, 'sortByDefault', 'sortDescDefault')
      }

      return this.atualizarPaginacaoInterna(paginacao, 'sortBy', 'sortDesc')
    },
    tratarEventoAtualizarPagina(page) {
      this.paginacaoInterna.page = page
    },
    tratarEventoAtualizarItensPorPagina(rowsPerPage) {
      this.paginacaoInterna.page = 1
      this.paginacaoInterna.rowsPerPage = rowsPerPage
    },
    async adicionarDemanda(){
      const orgaoSelecionadoId = this.selectedOrgaoId;
      const credenciadoSelecionado = this.selectedCredenciado;
      const itensComQuantidade = this.itens.filter(item => item.quantidade > 0);
      const itensParaEnviar = itensComQuantidade.map(item => ({
        id: item.id,
        quantidade: item.quantidade
      }));

      if (!orgaoSelecionadoId) {
        this.mostrarErro('Selecione um órgão');
        return;
      }

      if (!credenciadoSelecionado) {
        this.mostrarErro('Selecione um credenciado');
        return;
      }

      if (itensParaEnviar.length === 0) {
        this.mostrarErro('É necessário incluir pelo menos um item');
        return;
      }

      if (!this.deveJustificarEscolha && !this.motivo) {
        this.mostrarErro('É necessário incluir o motivo da escolha do fornecedor');
        return;
      }

      try {
        this.habilitarLoadingGlobal()

      const dados = {
        idUnidadeOrganizacional: orgaoSelecionadoId,
        idFornecedor: credenciadoSelecionado.id,
        classificacaoFornecedor: credenciadoSelecionado.classificacao,
        motivoEscolhaFornecedor: !this.deveJustificarEscolha ? this.motivo : null,
        ehFornecedorSugerido: this.deveJustificarEscolha,
        itens: itensParaEnviar
      };

      const payload = {
        credenciamentoId: this.licitacaoId,
        dados: dados
      }

      const resposta = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.ADICIONAR_NOVA_DEMANDA, payload)
      if (resposta) {
        this.dialog = false
        this.$emit('atualizar')
      }
        this.mostrarNotificacaoSucessoDefault()
        this.desabilitarLoadingGlobal()
      } catch (e) {
        this.desabilitarLoadingGlobal()
      }
    },
    naoDeveJustificarEscolha() {
      if (this.selectedCredenciado && this.credenciados.length > 0) {
        this.deveJustificarEscolha = this.credenciados[0].id === this.selectedCredenciado.id
      } else {
        this.deveJustificarEscolha = true
      }
    }
  }
}
</script>

<style>
  .custom-header thead th {
    color: #0067a5 !important;
  }
  .dialog-custom {
    width: 90vw !important;
    height: 95vh !important;
    max-width: none !important;
    max-height: none !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dialog-custom > .v-card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .scrollable-body {
    flex: 1 1 auto;        /* Ocupa o espaço restante da coluna */
    min-height: 0;         /* Impede crescimento desnecessário */
    overflow-y: auto;      /* Ativa rolagem vertical quando necessário */
    padding: 1rem;
    display: flex;         /* Permite o uso de v-container normalmente */
    flex-direction: column;
  }
</style>